import messages from "./enter-secret-question-answer-form-messages";
import { VALIDATION_ERROR_ISSUES } from "../../../../../constants";
const { WRONG_ANSWER } = VALIDATION_ERROR_ISSUES;

export default {
  [`secretQuestionAnswer_${WRONG_ANSWER}`]: messages.wrongAnswer
};
